import * as React from "react";
import createSvgIcon from "../SvgIcon/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g id="Layer_1">
      <polygon
        points="136.97 8.66 6.18 174.88 136.97 174.88 136.97 8.66"
        fill="none"
        stroke="#1d1d1b"
        strokeWidth="6px"
        strokeMiterlimit="10"
      />
      <polygon
        points="112.69 72.5 53.37 149.77 112.69 149.77 112.69 72.5"
        fill="none"
        stroke="#1d1d1b"
        strokeWidth="6px"
        strokeMiterlimit="10"
      />
      <path
        d="M126.75,44.42h6.03c.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77c-.06-1.35-1.1-2.5-2.5-2.5h-6.03c-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77c.06,1.35,1.1,2.5,2.5,2.5h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M127.76,58.49h7.03c1.31,0,2.56-1.15,2.5-2.5s-1.1-2.5-2.5-2.5h-7.03c-1.31,0-2.56,1.15-2.5,2.5s1.1,2.5,2.5,2.5h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M127.76,71.55c1.84,0,3.68,0,5.53,0,.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73c-1.84,0-3.68,0-5.53,0-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M127.76,87.12h5.02c.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73h-5.02c-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M129.27,102.19h5.53c.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73h-5.53c-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M128.76,119.77c1.34,0,2.68,0,4.02,0,.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73c-1.34,0-2.68,0-4.02,0-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M128.76,134.34h5.53c.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73h-5.53c-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M129.27,148.4h4.02c.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73h-4.02c-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M128.26,159.96c1.84,0,3.68,0,5.53,0,.64,0,1.31-.28,1.77-.73s.76-1.15.73-1.77-.24-1.32-.73-1.77-1.09-.73-1.77-.73c-1.84,0-3.68,0-5.53,0-.64,0-1.31.28-1.77.73s-.76,1.15-.73,1.77.24,1.32.73,1.77,1.09.73,1.77.73h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M159.92,8.29c-2.54,6.24-4.05,12.85-4.43,19.58s.67,13.54,1.83,20.25c1.09,6.34,1.77,12.59,1.29,19.03-.44,5.99-1.67,11.89-3.11,17.72-2.94,11.92-6.84,23.65-8.14,35.92-.66,6.2-.49,12.44.68,18.57,1.29,6.75,3.67,13.23,5.91,19.7,1.16,3.36,2.3,6.73,3.48,10.08.97,2.77,2.14,5.61,4.59,7.4,2.27,1.66,5.59,2.13,8.05.58,2.72-1.72,3.32-5.35,3.61-8.29.67-6.67-1.65-13.19-4.07-19.29s-4.8-12.3-5.1-19.02,1.17-12.81,3.51-18.9,5.25-11.79,7.27-17.92,3.22-12.97,3.42-19.62-.79-13.3-2.2-19.85-3.01-12.76-2.88-19.3c.06-3.17.64-6.22,1.74-9.2s2.5-5.73,3.29-8.76c1.33-5.07.49-11.18-4-14.46-4.74-3.47-10.26-.54-13.38,3.57-1.45,1.91-2.58,4.21-2.91,6.6-.18,1.29.31,2.6,1.69,2.97,1.13.31,2.8-.39,2.97-1.69.45-3.3,3.55-8.68,7.3-8.19,1.49.19,2.81,1.7,3.44,3.22.79,1.92.82,4.04.37,6.05-.67,2.91-1.97,5.61-3.06,8.37s-1.83,5.77-2.14,8.82c-.64,6.27.6,12.61,1.91,18.71s2.71,12.07,2.98,18.29-.33,12.32-1.81,18.3c-2.93,11.86-10.14,22.31-11.9,34.49-.92,6.39-.53,12.93,1.28,19.14s4.79,11.8,6.45,17.95c.78,2.88,1.24,5.81,1.06,8.8-.09,1.47-.19,5.23-2.21,5.31-2.29.08-3.53-2.47-4.2-4.27-1.1-2.93-2.06-5.92-3.08-8.89-2.11-6.12-4.39-12.23-5.94-18.53-1.41-5.74-1.9-11.54-1.55-17.44.69-11.47,4.23-22.56,7.13-33.61s5.47-22.86,4.27-34.53c-.65-6.34-2.2-12.55-2.81-18.9s-.26-12.48,1.17-18.56c.72-3.06,1.71-6.05,2.89-8.96.49-1.21-.54-2.66-1.69-2.97-1.38-.38-2.48.47-2.97,1.69h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M158.25,26.62c1.81,1.61,4.11,2.28,6.5,2.35,1.2.03,2.4-.09,3.58-.24,1.27-.16,2.55-.26,3.66-.96.78-.49,1.09-1.52.61-2.34s-1.55-1.11-2.34-.61c-.65.41-1.44.43-2.27.53-1,.12-2.01.22-3.03.2-1.56-.02-3.2-.37-4.31-1.36-.69-.61-1.74-.68-2.42,0-.62.62-.69,1.8,0,2.42h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M161.63,73.49c4.72.77,10.74,1.05,14.45-2.54,1.58-1.53-.83-3.94-2.42-2.42-1.16,1.12-2.96,1.7-4.51,1.87-2.19.23-4.44.15-6.62-.21-.91-.15-1.84.24-2.1,1.19-.22.82.28,1.95,1.19,2.1h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M150.37,111.64c2.01,1.79,4.42,2.98,6.99,3.75,1.23.37,2.51.68,3.79.78,1.48.11,2.78-.27,3.95-1.18.73-.56.59-1.82,0-2.42-.72-.72-1.68-.57-2.42,0,.05-.04-.12.05-.21.08-.12.04-.24.07-.36.09.15,0,.11,0-.1.01-.26.02-.51.01-.77,0,.02,0-.57-.06-.32-.03-1.03-.15-2.07-.44-3.06-.76-1.83-.59-3.65-1.47-5.08-2.75-.69-.61-1.74-.68-2.42,0-.62.62-.69,1.8,0,2.42h0Z"
        fill="#1d1d1b"
      />
      <path
        d="M152.36,145.91c3.96,1.51,8.61.48,11.72-2.36.66-.6.66-1.81,0-2.42-.71-.65-1.71-.64-2.42,0-.15.14-.3.27-.46.4.13-.11.1-.07-.01.01-.1.07-.21.15-.31.22-.34.22-.69.43-1.05.61-.09.05-.18.09-.27.13-.12.06-.31.12-.08.04-.19.07-.38.14-.57.21-.41.13-.83.24-1.25.32-.1.02-.2.03-.3.05-.26.05.27-.02,0,0-.2.02-.4.04-.61.05-.43.02-.86.02-1.29-.02-.1,0-.2-.02-.3-.03-.17-.02-.16-.03,0,0-.2-.04-.4-.07-.6-.11-.44-.1-.88-.24-1.3-.4-.84-.32-1.91.35-2.1,1.19-.22.97.3,1.76,1.19,2.1h0Z"
        fill="#1d1d1b"
      />
    </g>
  </React.Fragment>,
  "Stage2",
  {
    viewBox: "0 0 179.22 178.07",
    width: "78",
    height: "75",
  }
);
